import { render, staticRenderFns } from "./ReportLocationTruck.vue?vue&type=template&id=32136ad8&scoped=true&"
import script from "./ReportLocationTruck.vue?vue&type=script&lang=ts&"
export * from "./ReportLocationTruck.vue?vue&type=script&lang=ts&"
import style0 from "./ReportLocationTruck.vue?vue&type=style&index=0&id=32136ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32136ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
